function scrollTo(element, offsetElem = 100) {
  let bodyRect = document.body.getBoundingClientRect();
  let elemRect = element.getBoundingClientRect();
  let offset = elemRect.top - bodyRect.top;
  console.log(offset);
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: offset - offsetElem - 40,
  });
}

// RAWeb 13.8 — mouvement maîtrisé : met en pause les vidéos en lecture automatique
// quand l'utilisateur préfère moins d'animations (réglage OS) ou a activé le mode
// accessible (bouton ♿). Relancées si la préférence change.
function manageMotionVideos() {
  const reduce =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    document.documentElement.classList.contains("dark");
  document.querySelectorAll("video[autoplay]").forEach((v) => {
    if (reduce) {
      v.pause();
    } else if (v.paused) {
      v.play().catch(() => {});
    }
  });
}
try {
  window
    .matchMedia("(prefers-reduced-motion: reduce)")
    .addEventListener("change", manageMotionVideos);
  new MutationObserver(manageMotionVideos).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
} catch (e) {}

document.addEventListener("DOMContentLoaded", function () {
  manageMotionVideos();
  if (document.querySelector(".main-content").offsetHeight > window.innerHeight) {
    document.documentElement.classList.add("scrollbar-stable");
  }

  // if (document.querySelectorAll(".scroll-to-video").length > 0) {
  //   document.querySelectorAll(".scroll-to-video").forEach((element) => {
  //     element.addEventListener("click", function () {
  //       if (element.getAttribute("id") === "playButtonOverlay" && window.scrollY < 200) {
  //         if (window.innerWidth < 1930) {
  //           scrollTo(document.getElementById("slide1"), 350);
  //         } else {
  //           scrollTo(document.getElementById("slide1"), 1000);
  //         }
  //       } else if (element.dataset.aftervideo) {
  //         scrollTo(document.getElementById("videoCircle"), -350);
  //       } else if (!(element.getAttribute("id") == "playButtonOverlay")) {
  //         if (window.innerWidth < 1930) {
  //           scrollTo(document.getElementById("slide1"), 130);
  //         } else {
  //           scrollTo(document.getElementById("slide1"), 1000);
  //         }
  //       }
  //     });
  //   });
  // }

  if (document.querySelectorAll(".scroll-to-video").length > 0) {
    document.querySelectorAll(".scroll-to-video").forEach((element) => {
      element.addEventListener("click", function () {
        positionScroll = window.innerWidth < 1920 ? 260 : 1050;
        if (element.getAttribute("id") === "playButtonOverlay" && window.scrollY < 100) {
          scrollTo(document.getElementById("slide1"), positionScroll);
        } else if (element.dataset.aftervideo) {
          scrollTo(document.getElementById("videoCircle"), positionScroll);
        } else if (!(element.getAttribute("id") == "playButtonOverlay")) {
          scrollTo(document.getElementById("slide1"), positionScroll);
        }
      });
    });
  }

  /*
   ** Scroll anchors
   */

  if (document.querySelectorAll('a[href^="#"]').length > 0) {
    let anchors = document.querySelectorAll('a[href^="#"]');
    for (const anchor of anchors) {
      if (anchor.getAttribute("href").match(/#[a-zA-Z0-9]/)) {
        anchor.addEventListener("click", (e) => {
          let height = 0;
          if (document.querySelectorAll("header").length > 0) {
            height = document.querySelector("header").offsetHeight;
          }
          e.preventDefault();
          console.log(document.getElementById(anchor.getAttribute("href").replace("#", "")));
          scrollTo(document.getElementById(anchor.getAttribute("href").replace("#", "")), height);
        });
      }
    }
  }

  // Wrap allthe table element with a new div with the class wrapper-table
  if (document.querySelectorAll("table").length > 0) {
    let tables = document.querySelectorAll("table");
    for (const table of tables) {
      let wrapper = document.createElement("div");
      wrapper.classList.add("wrapper-table");
      table.parentElement.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      // RAWeb 5.3 : une table dépourvue d'en-têtes est une table de mise en forme ;
      // on la rend présentationnelle pour qu'elle ne soit pas restituée comme un
      // tableau de données par les technologies d'assistance.
      if (!table.querySelector("th") && !table.querySelector("thead")) {
        table.setAttribute("role", "presentation");
      }
    }
  }

  // RAWeb 7.4 : avertir de l'ouverture dans une nouvelle fenêtre/onglet.
  // Passe globale : ajoute un texte visuellement masqué à chaque lien target="_blank"
  // (hors widgets tiers), localisé selon la langue du document.
  {
    const lang = (document.documentElement.lang || "fr").toLowerCase();
    const newWindowLabel = lang.startsWith("en")
      ? " (new window)"
      : lang.startsWith("de")
      ? " (neues Fenster)"
      : " (nouvelle fenêtre)";
    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      if (link.dataset.blankAnnotated) return;
      if (link.closest('[class*="crt"], .lg-outer, [class*="a2a"]')) return; // widgets tiers
      const existing = (link.getAttribute("aria-label") || "") + " " + link.textContent;
      if (/nouvelle fen[êe]tre|new window|neues fenster/i.test(existing)) return;
      link.dataset.blankAnnotated = "1";
      const note = document.createElement("span");
      note.className = "sr-only";
      note.textContent = newWindowLabel;
      link.appendChild(note);
    });
  }

  // RAWeb 8.9 : neutraliser les balises utilisées uniquement à des fins de présentation.
  // Les <hr> du site sont des séparateurs décoratifs (bordures/fonds colorés) -> présentation.
  document.querySelectorAll("hr").forEach((hr) => {
    if (!hr.hasAttribute("role")) hr.setAttribute("role", "presentation");
  });
  // Balises sémantiques vides (paragraphe / emphase / titre sans texte ni média).
  document
    .querySelectorAll("p, strong, b, em, h1, h2, h3, h4, h5, h6")
    .forEach((el) => {
      const txt = el.textContent.replace(/ /g, "").trim();
      if (
        txt === "" &&
        !el.querySelector("img, svg, iframe, input, button, a, picture")
      ) {
        el.setAttribute("role", "presentation");
      }
    });

  // Calulate height of element with js-height-calculation class
  if (document.querySelectorAll(".js-height-calculation").length > 0) {
    let elements = document.querySelectorAll(".js-height-calculation");
    setTimeout(() => {
      for (const element of elements) element.parentElement.style.height = element.scrollHeight + "px";
    }, 300);
  }

  /*
   * AUDIO
   */

  if (document.querySelectorAll(".js-audio").length > 0) {
    // const countdownTimer = document.querySelector('.js-duration');

    if (document.querySelectorAll(".js-play-audio").length > 0) {
      // let playAudio = document.querySelector('.js-play-audio');
      let playAudios = document.querySelectorAll(".js-play-audio");
      for (const playAudio of playAudios) {
        playAudio.addEventListener("click", (e) => {
          e.preventDefault();
          const pauseBtn = document.querySelector(".js-pause-audio.js-index-" + playAudio.dataset.index);
          pauseBtn.classList.remove("hidden");
          document.querySelector(".js-play-audio.js-index-" + playAudio.dataset.index).classList.add("hidden");
          document.querySelector(".svg-audio.js-index-" + playAudio.dataset.index).classList.add("played");
          document.querySelector(playAudio.dataset.player).play();
          // Garde le focus clavier sur le contrôle visible (RAWeb 4.10)
          if (document.activeElement === playAudio) pauseBtn.focus();
        });

        document.querySelector(playAudio.dataset.player).addEventListener("ended", () => {
          // countdownTimer.textContent = formatAudioLength(0);
          document.querySelector(".svg-audio.js-index-" + playAudio.dataset.index).classList.remove("played");
          document.querySelector(".js-pause-audio.js-index-" + playAudio.dataset.index).classList.add("hidden");
          document.querySelector(".js-play-audio.js-index-" + playAudio.dataset.index).classList.remove("hidden");
        });
      }
    }

    if (document.querySelectorAll(".js-pause-audio").length > 0) {
      // let pauseAudio = document.querySelector('.js-pause-audio');
      let pauseAudios = document.querySelectorAll(".js-pause-audio");
      for (const pauseAudio of pauseAudios) {
        pauseAudio.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector(".js-pause-audio.js-index-" + pauseAudio.dataset.index).classList.add("hidden");
          const playBtn = document.querySelector(".js-play-audio.js-index-" + pauseAudio.dataset.index);
          playBtn.classList.remove("hidden");
          document.querySelector(".svg-audio.js-index-" + pauseAudio.dataset.index).classList.remove("played");
          document.querySelector(pauseAudio.dataset.player).pause();
          // Garde le focus clavier sur le contrôle visible (RAWeb 4.10)
          if (document.activeElement === pauseAudio) playBtn.focus();
        });
      }
    }
  }

  if (document.querySelectorAll(".lightgallery").length > 0) {
    let galleries = document.querySelectorAll(".lightgallery");

    for (const gallery of galleries) {
      lightGallery(gallery, {
        licenseKey: "8CAA63FC-B4904F57-8FFDCD7B-AD332B1A",
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
          download: false,
        },
      });
    }
  }

  if (document.querySelectorAll(".lightgallery-video").length > 0) {
    let galleriesVideo = document.querySelectorAll(".lightgallery-video");

    for (const gallery of galleriesVideo) {
      lightGallery(gallery, {
        licenseKey: "8CAA63FC-B4904F57-8FFDCD7B-AD332B1A",
        plugins: [lgVideo],
        getCaptionFromTitleOrAlt: false,
        download: false,
        youtubePlayerParams: {
          modestbranding: 1,
          showinfo: 0,
          rel: 0,
          controls: 1,
        },
        videojs: true,
        videojsOptions: {
          muted: false,
        },
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
          download: false,
        },
      });

      // RAWeb (Multimédia / Cadres) : corrige l'accessibilité de la modale vidéo
      // générée par LightGallery (lib tierce) — libellés FR, title d'iframe, frameborder.
      // L'iframe se construisant en asynchrone, on ré-applique le patch (idempotent)
      // quelques fois après le clic, le temps que la modale et la vidéo se montent.
      const fixVideoModalA11y = () => {
        const close = document.querySelector(".lg-close");
        if (close && close.getAttribute("aria-label") !== "Fermer la vidéo") {
          close.setAttribute("aria-label", "Fermer la vidéo");
        }
        const iframe = document.querySelector(".lg-video-object, .lg-outer iframe");
        if (iframe) {
          if (iframe.hasAttribute("frameborder")) iframe.removeAttribute("frameborder");
          if (!iframe.getAttribute("title")) {
            const trigger = gallery.querySelector("[data-src]");
            const t = (trigger && (trigger.getAttribute("title") || trigger.getAttribute("aria-label"))) || "Vidéo";
            iframe.setAttribute("title", t);
          }
        }
      };
      gallery.addEventListener("click", () => {
        let tries = 0;
        const iv = setInterval(() => {
          fixVideoModalA11y();
          if (++tries > 10) clearInterval(iv);
        }, 200);
      });
    }
  }

  if (document.querySelectorAll(".js-select-adaptatif").length > 0) {
    const selectElements = document.querySelectorAll(".js-select-adaptatif");
    const tempMeasurers = document.querySelectorAll(".js-temp-width-measurer");

    function updateSelectWidth(selectElement, tempMeasurer, size) {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      tempMeasurer.textContent = selectedOption.textContent;
      const newWidth = tempMeasurer.offsetWidth + size;
      selectElement.style.width = newWidth + "px";
    }

    for (let i = 0; i < selectElements.length; i++) {
      updateSelectWidth(selectElements[i], tempMeasurers[i], 40);
    }

    for (let i = 0; i < selectElements.length; i++) {
      selectElements[i].addEventListener("change", () => {
        updateSelectWidth(selectElements[i], tempMeasurers[i], 45);
      });
    }
  }

  /*
   ** Remove overlay
   */

  if (document.querySelectorAll(".js-remove-overlay").length > 0) {
    let overlays = document.querySelectorAll(".js-remove-overlay");
    for (const overlay of overlays) {
      overlay.addEventListener("click", (e) => {
        e.preventDefault();
        document.getElementById(overlay.getAttribute("data-removeOverlay")).classList.add("hidden");

        if (document.querySelector("." + overlay.getAttribute("data-arrowShow"))) {
          let arrow = document.querySelector("." + overlay.getAttribute("data-arrowShow"));
          arrow.classList.remove("hidden");
        }

        if (document.getElementById(overlay.getAttribute("data-playVideo"))) {
          let play = document.getElementById(overlay.getAttribute("data-playVideo"));
          play.src = play.src + "&autoplay=1";
        }
      });
    }
  }

  if (document.querySelectorAll(".js-search-link").length > 0) {
    let searchLinks = document.querySelectorAll(".js-search-link");
    for (const searchLink of searchLinks) {
      searchLink.addEventListener("click", (e) => {
        e.preventDefault();
        let searchQuery = searchLink.getAttribute("data-search");
        let searchInput = document.querySelector(".input-search-desktop");
        let searchInputMobile = document.querySelector(".input-search-mobile");
        if (searchInput) {
          searchInput.value = searchQuery;
          searchInput.focus();
        }
        if (searchInputMobile) {
          searchInputMobile.value = searchQuery;
          searchInputMobile.focus();
        }
      });
    }
  }
});

// (function () {
//   "use strict";
//   window.addEventListener(
//     "load",
//     function () {
//       // Fetch all the forms we want to apply custom Bootstrap validation styles to
//       let forms = document.getElementsByClassName("needs-validation");
//       // Loop over them and prevent submission
//       let validation = Array.prototype.filter.call(forms, function (form) {
//         form.addEventListener(
//           "submit",
//           function (event) {
//             if (form.checkValidity() === false) {
//               event.preventDefault();
//               event.stopPropagation();
//             }
//             form.classList.add("was-validated");
//           },
//           false
//         );
//       });
//     },
//     false
//   );
// })();

// let targetY = window.scrollY;
// let currentY = targetY;
// let isAnimating = false;
// const lerpFactor = 0.1; // Facteur d'interpolation pour la fluidité (0.05 à 0.2)
// const scrollSensitivity = 0.5; // Sensibilité de la molette

// window.addEventListener(
//   "wheel",
//   (e) => {
//     e.preventDefault(); // Empêche le défilement par défaut

//     // Mettre à jour la position cible
//     targetY = Math.max(0, targetY + e.deltaY * scrollSensitivity);

//     if (!isAnimating) {
//       isAnimating = true;
//       smoothScroll();
//     }
//   },
//   { passive: false }
// );

// function smoothScroll() {
//   // Interpolation linéaire pour approcher la cible
//   currentY += (targetY - currentY) * lerpFactor;

//   // Arrêter si assez proche
//   if (Math.abs(currentY - targetY) < 0.1) {
//     window.scrollTo(0, targetY);
//     isAnimating = false;
//     return;
//   }

//   window.scrollTo(0, currentY);

//   // Continuer l'animation
//   requestAnimationFrame(smoothScroll);
// }
